import { render, staticRenderFns } from "./ChannelSort.vue?vue&type=template&id=0057ea06"
import script from "./ChannelSort.vue?vue&type=script&lang=js"
export * from "./ChannelSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0057ea06')) {
      api.createRecord('0057ea06', component.options)
    } else {
      api.reload('0057ea06', component.options)
    }
    module.hot.accept("./ChannelSort.vue?vue&type=template&id=0057ea06", function () {
      api.rerender('0057ea06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/stock/rules/components/ChannelSort.vue"
export default component.exports